module.exports = __webpack_public_path__ + "static/assets/af5b31826bfe24b5685004de70299b82.png";